// extracted by mini-css-extract-plugin
export var section = "styles-module--section--1hoDD";
export var img = "styles-module--img--19_Tm";
export var content = "styles-module--content--2DmX-";